/**
 * Монета — своей графикой, а не эмодзи: по той же причине, что и значки меню
 * (lobby/icons.tsx), — эмодзи в каждой системе рисуется по-своему.
 *
 * Одна на карточку заданий и магазин: монета там и там одна и та же.
 */
export function CoinIcon() {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" className="coin">
      <circle cx="8" cy="8" r="6.5" fill="currentColor" />
      <circle cx="8" cy="8" r="3.8" fill="none" stroke="var(--card)" strokeWidth="1.4" />
    </svg>
  )
}
